import { $api } from './interceptor';
import { Paginated } from 'types/paginated';
import { IAdminLog, IAdminLogsParams } from 'views/types/adminLogs';

const adminLogsApi = () => {
  const getPaginatedAdminLogsList = async ({
    page = 0,
    pageSize = 10,
    searchValue = '',
    sortBy,
    sortOrder,
    filter = {},
  }: IAdminLogsParams): Promise<Paginated<IAdminLog>> => {
    const params: Record<string, string> = {
      page: String(page + 1),
      limit: String(pageSize),
    };

    if (searchValue) params.search = searchValue;
    if (sortBy) params.sortBy = sortBy;
    if (sortOrder) params.sortOrder = sortOrder;

    const searchParams = new URLSearchParams(params);

    Object.entries(filter).forEach(([key, val]) => {
      if (val != null) {
        searchParams.append(`filter.${key}`, val);
      }
    });

    const url = `api/admin-logs?${searchParams.toString()}`;

    const { data } = await $api.get<Paginated<IAdminLog>>(url);
    return data;
  };

  const exportAdminLogsToCsv = async (
    filters?: Record<string, string | number | boolean>
  ) => {
    try {
      const response = await $api.post(
        'api/admin-logs/export-csv',
        filters || {},
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], {
        type: 'text/csv;charset=utf-8',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `admin_logs_${Date.now()}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export Admin Logs CSV failed', err);
    }
  };

  const logKycView = async (userId: string): Promise<void> => {
    try {
      await $api.post('api/admin-logs/kyc-view', { userId });
    } catch (err) {
      console.error('Log KYC view failed', err);
    }
  };

  return {
    getPaginatedAdminLogsList,
    exportAdminLogsToCsv,
    logKycView,
  };
};

export const adminLogsService = adminLogsApi();
